import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { modesRegistryQueryKey } from "./useModesRegistry";
import { apiClient } from "../utils/api";

export const usePurchaseOptions = () => {
  return useQuery({
    queryKey: ["purchaseOptions"],
    queryFn: () => apiClient.getPurchaseOptions(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const usePaymentMethods = () => {
  return useQuery({
    queryKey: ["paymentMethods"],
    queryFn: () => apiClient.getPaymentMethods(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const usePurchase = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      purchase_option: number;
      discount_code?: number;
      payment_method?: number;
      token?: string;
      is_app?: boolean;
    }) => apiClient.purchase(data),
    onSuccess: (data) => {
      if (!data.payment_url) {
        // Free purchase or immediate success
        queryClient.invalidateQueries({ queryKey: ["userCredits"] });
        queryClient.invalidateQueries({ queryKey: modesRegistryQueryKey });
        navigate("/");
      }
      // If payment_url exists, frontend will handle redirect
    },
  });
};

export const useApplyCoupon = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code: string) => apiClient.applyCoupon(code),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userCredits"] });
      queryClient.invalidateQueries({ queryKey: modesRegistryQueryKey });
    },
  });
};

export const useApplyDiscountCode = () => {
  return useMutation({
    mutationFn: (code: string) => apiClient.applyDiscountCode(code),
  });
};
